import React, { useState } from 'react';

const PatentPage = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [currentTitle, setCurrentTitle] = useState('');

  const openLightbox = (imageSrc, title) => {
    setCurrentImage(imageSrc);
    setCurrentTitle(title);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setCurrentImage('');
    setCurrentTitle('');
    document.body.style.overflow = 'auto';
  };

  // Handle Escape key press
  React.useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, []);

  return (
    <div>
      {/* Single Section: MAOSENTE GDT Patent 2026 - ចម្បង & បន្ទាប់បន្សំ */}
      <section id="patent" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-12">
            <span className="text-sm font-semibold text-[#215f9a] uppercase tracking-wider">
              Intellectual Property
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
              MAOSENTE GDT Patent 2026
            </h2>
            <div className="w-16 h-1 bg-[#215f9a] mx-auto mb-6"></div>
            
          </div>

          {/* 1 Row, 2 Column Image Grid */}
          <div className="grid md:grid-cols-1 gap-8">
            {/* Image 1: Main Patent */}
            <div 
              className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group cursor-pointer"
              onClick={() => openLightbox('/img/patent/patentmain1.png', 'MAOSENTE GDT Patent 2026 - Main Patent (ចម្បង)')}
            >
              <div className="overflow-hidden">
                <img
                  src="/img/patent/patentmain1.png"
                  alt="MAOSENTE GDT Patent 2026 Main - Certificate"
                  className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 text-center border-t border-gray-100">
                <p className="text-sm text-gray-500">ប៉ាតង់ចម្បង - Main Patent</p>
                <span className="text-xs text-[#215f9a] mt-1 inline-block opacity-0 group-hover:opacity-100 transition-opacity">
                  Click to enlarge
                </span>
              </div>
            </div>

            
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightboxOpen && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm"
          onClick={closeLightbox}
        >
          <div 
            className="relative max-w-5xl w-full mx-4"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors duration-200"
            >
              <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Image Container */}
            <div className="bg-white rounded-lg overflow-hidden shadow-2xl">
              <img
                src={currentImage}
                alt={currentTitle}
                className="w-full h-auto max-h-[85vh] object-contain"
              />
              <div className="p-4 text-center bg-white">
                <p className="text-gray-700">{currentTitle}</p>
              </div>
            </div>

            {/* Instructions */}
            <p className="text-center text-white/60 text-sm mt-4">
              Click anywhere outside to close • Press ESC to exit
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PatentPage;